import React from "react";
import type {HeatRegistration} from '@iziping/common';
import {formatPlayers} from '@iziping/common';
import {CircleUser} from "lucide-react";

interface HeatRegistrationCardProps {
    registration: HeatRegistration;
}

const HeatRegistrationCard: React.FC<HeatRegistrationCardProps> = ({registration}) => {

    return (
        <div>
            {registration &&
                <div>
                    {registration.players.length === 1 &&
                        <CircleUser/>
                    }
                    {registration.players.length === 2 &&
                        <>
                            <CircleUser/>
                            <CircleUser/>
                        </>
                    }
                    {formatPlayers(registration)}
                </div>
            }
        </div>
    )
};

export default HeatRegistrationCard;